import { IvdEnvironment, Profile, Tenants } from '@state/reducers/app/app.model';
import { AppActions, AppActionTypes } from '../../actions/app/app.actions';

export interface IAppState {
    profile: Profile;
    tenants: Tenants;
    environment: IvdEnvironment;
}

export const initialState: IAppState = {
    profile: new Profile(),
    tenants: new Tenants(),
    environment: new IvdEnvironment()
};

export function reducer(state = initialState, action: AppActions): IAppState {
    switch (action.type) {

        case AppActionTypes.CLEAR_PROFILE: {
            const profile = new Profile(null, null);

            return {
                ...state,
                profile: Object.assign(new Profile(), { ...profile, pending: false }),
            };
        }

        case AppActionTypes.RETRIEVE_PROFILE_PENDING: {
            const profile = new Profile(null, null);

            return {
                ...state,
                profile: Object.assign(new Profile(), { ...profile, pending: true })
            };
        }

        case AppActionTypes.PROFILE_RETRIEVED: {
            const payload = (action).payload;
            return {
                ...state,
                profile: Object.assign(new Profile(), { ...{ ...payload, pending: false } })
            };
        }

        case AppActionTypes.CRMS_RETRIEVED: {
            const payload = (action).payload;
            return {
                ...state,
                environment: Object.assign(new IvdEnvironment(payload.crms, state.environment.tenantSettings, state.environment.userProvisioning))
            };
        }

        case AppActionTypes.PROVISIONING_RETRIEVED: {
            const payload = (action).payload;
            return {
                ...state,
                environment: Object.assign(new IvdEnvironment(state.environment.crms, state.environment.tenantSettings, payload.provisioning))
            };
        }

        case AppActionTypes.TENANTSETTINGS_RETRIEVED: {
            const payload = (action).payload;
            return {
                ...state,
                environment: Object.assign(new IvdEnvironment(state.environment.crms, payload.setttings, state.environment.userProvisioning))
            };
        }

        default:
            return state;
    }
}
